import { Injectable } from '@angular/core';
import type { Theming } from '@vendasta/protos/atlas/v1/types';

@Injectable({ providedIn: 'root' })
export class AtlasThemingService {
  public set theming(value: Theming) {
    if (!value) {
      return;
    }
    this.themingWrapper.style.setProperty('--themingPrimaryColor', value.primaryColor);
    this.themingWrapper.style.setProperty('--themingPrimaryHoverColor', value.primaryHoverColor);
    this.themingWrapper.style.setProperty('--themingPrimaryActiveColor', value.primaryActiveColor);
    this.themingWrapper.style.setProperty('--themingSecondaryColor', value.secondaryColor);
    this.themingWrapper.style.setProperty('--themingSecondaryHoverColor', value.secondaryHoverColor);
    this.themingWrapper.style.setProperty('--themingSecondaryActiveColor', value.secondaryActiveColor);
    this.themingWrapper.style.setProperty('--themingFontColor', value.fontColor);
    this.themingWrapper.style.setProperty('--themingFontDisabledColor', value.fontDisabledColor);
    this.themingWrapper.style.setProperty('--themingAccentsColor', value.accentsColor);
    this.themingWrapper.style.setProperty('--themingAccentsActiveColor', value.accentsActiveColor);
    this.themingWrapper.style.setProperty('--themingFocusColor', value.focusColor);
    this.themingWrapper.style.setProperty('--themingBorderColor', value.borderColor);
  }

  private themingWrapper = document.querySelector('body');
}
